const BASE_URL = process.env.REACT_APP_BASE_URL;
const FILE_FETCH_URL = process.env.REACT_APP_UPLOAD_ENDPOINT;

const ADMIN_BASE_URL = BASE_URL + "admin/";
const CLASS_BASE_URL = BASE_URL + "class/";
const STATE_BASE_URL = BASE_URL + "state/";
const DISTRICT_BASE_URL = BASE_URL + "district";
const PINCODE_BASE_URL = BASE_URL + "pincode";
const TALUKA_BASE_URL = BASE_URL + "taluka";
const SUBJECT_BASE_URL = BASE_URL + "subject/";
const STUDY_MATERIAL_BASE_URL = BASE_URL + "studyMaterial/";
const QUESTION_BANK_BASE_URL = BASE_URL + "questionBank/";
const BLOG_CATEGORY_BASE_URL = BASE_URL + "blogCategory/";
const BLOG_BASE_URL = BASE_URL + "blog/";
const AUTHER_BASE_URL = BASE_URL + "author/";
const TESTIMONIAL_BASE_URL = BASE_URL + "testimonial/";
const FAQS_BASE_URL = BASE_URL + "faqCategory/";
const FAQS_URL = BASE_URL + "faq/";
const CONTACT_URL = BASE_URL + "contact/";
const REGISTRATION_URL = BASE_URL + "user/";
const BHARASETEXAM_URL = BASE_URL + "bharatSat/";
const COORDINATOR_URL = BASE_URL + "coordinator/";
const PRIVACY_POLICY_URL = BASE_URL + "privacyPolicy/";
const TERMS_AND_CONDITIONS = BASE_URL + "termsConditions/";
const CANCELLATION_POLICY = BASE_URL + "cancellationPolicy/";
const ABOUT_US_URL = BASE_URL + "user/";
const SOCIAL_MEDIA_URL = BASE_URL + "user/";
const HOMEPAGE_SLIDER_IMAGE = BASE_URL + "sliders/";
const MOBILE_BANNER = BASE_URL + "mobileBanner/";
const MOCK_TEST_BASE_URL = BASE_URL + "mockTest/";
const PACKAGES_BASE_URL = BASE_URL + "package/";
const ROLE_BASE_URL = BASE_URL + "role/";
const STUDENT_BATCH_BASE_URL = BASE_URL + "studentBatch/";
const BHARATSATEXAM_BASE_URL = BASE_URL + "bharatSat/";
const BHARATSATEXAMRESULT_BASE_URL = BASE_URL + "viewResult/";
const REVIEWER_BASE_URL = BASE_URL + "reviewer/";
const COUPON_BASE_URL = BASE_URL + "coupon/";

const ApiConstants = {
  BASE_URL: BASE_URL,
  FILE_FETCH_URL: BASE_URL.concat(FILE_FETCH_URL),
  // - Auth Service Endpoints
  login: ADMIN_BASE_URL + "login",
  verifyOtp: ADMIN_BASE_URL + "verify-otp",
  forgotPassword: ADMIN_BASE_URL + "forget-password",
  resetPassword: ADMIN_BASE_URL + "reset-password",
  getAdminDetails: ADMIN_BASE_URL,
  changePassword: ADMIN_BASE_URL + "change-password",
  updateProfileDetails: ADMIN_BASE_URL + "updateProfileDetails",

  registerUser: REGISTRATION_URL + "register-user",
  getAllUsers: REGISTRATION_URL + "get-all-users",
  bulkUploadUsers: REGISTRATION_URL + "bulk-upload-users",
  getBulkUploadUsersHistory: REGISTRATION_URL + "get-bulk-upload-history",
  updateUserStatus: REGISTRATION_URL + "change-status",
  resetPassword: REGISTRATION_URL + "reset-password",
  resendCredentials: REGISTRATION_URL + "resend-credentials",
  // -Class Master Service Endpoints
  getAllClasses: CLASS_BASE_URL + "all",
  getAllClassesWithoutPagination: CLASS_BASE_URL + "getAllClasses",
  deleteClass: CLASS_BASE_URL + "deleteClass",
  addClass: CLASS_BASE_URL + "addclass",
  updateClass: CLASS_BASE_URL + "updateClass",
  updateClassStatus: CLASS_BASE_URL + "updateClassStatus",

  // -Subject Master Service Endpoints
  getAllSubjects: SUBJECT_BASE_URL + "all",
  getAllSubjectsWithoutPagination: SUBJECT_BASE_URL + "getAllSubjects",
  deleteSubject: SUBJECT_BASE_URL + "deleteSubject",
  addSubject: SUBJECT_BASE_URL + "addSubject",
  updateSubject: SUBJECT_BASE_URL + "updateSubject",
  updateSubjectStatus: SUBJECT_BASE_URL + "updateSubjectStatus",

  // -Study Material Service Endpoints
  getAllStudyMaterials: STUDY_MATERIAL_BASE_URL + "list-all-study-material",
  deleteStudyMaterial: STUDY_MATERIAL_BASE_URL + "delete-study-material",
  addStudyMaterial: STUDY_MATERIAL_BASE_URL + "add-study-material",
  updateStudyMaterialStatus: STUDY_MATERIAL_BASE_URL + "change-status",
  addModule: STUDY_MATERIAL_BASE_URL + "add-edit-module",
  addTopic: STUDY_MATERIAL_BASE_URL + "add-edit-topic",
  getAllModules: STUDY_MATERIAL_BASE_URL + "list-all-module",
  getAllModulesBySubject:
    STUDY_MATERIAL_BASE_URL + "list-all-module-by-subject",
  getAllTopics: STUDY_MATERIAL_BASE_URL + "list-all-topics",
  deleteModule: STUDY_MATERIAL_BASE_URL + "delete-module",
  deleteTopic: STUDY_MATERIAL_BASE_URL + "delete-topic",

  // -Question Bank Service Endpoints
  getAllQuestions: QUESTION_BANK_BASE_URL + "all-question-list",
  getAllSubQuestions: QUESTION_BANK_BASE_URL + "list-all-sub-question",
  getBulkUploadHistory: QUESTION_BANK_BASE_URL + "getBulkUploadHistory",
  deleteQuestion: QUESTION_BANK_BASE_URL + "delete-question",
  deleteSubQuestion: QUESTION_BANK_BASE_URL + "delete-sub-question",
  addQuestion: QUESTION_BANK_BASE_URL + "add-question",
  addSubQuestion: QUESTION_BANK_BASE_URL + "add-sub-question",
  updateQuestion: QUESTION_BANK_BASE_URL + "update-question",
  updateQuestionStatus: QUESTION_BANK_BASE_URL + "update-question-status",
  bulkUploadQuestions: QUESTION_BANK_BASE_URL + "bulk-upload-questions",

  //Blog Category Service Endpoints

  getBlogCategory: BLOG_CATEGORY_BASE_URL + "list-all-blog-category",
  addBlogCategory: BLOG_CATEGORY_BASE_URL + "add-blog-category",
  changeStatusBlogCategory: BLOG_CATEGORY_BASE_URL + "change-status",
  deleteBlogCategory: BLOG_CATEGORY_BASE_URL + "delete-blog-category",

  //Blog Service End Poibtes

  getAllCategoryWithoutPagination: BLOG_CATEGORY_BASE_URL + "get-all-blog-category",
  addBlog: BLOG_BASE_URL + "add-blog",
  getAllBlog: BLOG_BASE_URL + "list-all-blog",
  changeStatusBlog: BLOG_BASE_URL + "change-status",
  deleteBlog: BLOG_BASE_URL + "delete-blog",
  updateBlogSeo: BLOG_BASE_URL + "update-blog-seo",

  //Auther Service End Poibtes

  addAuther: AUTHER_BASE_URL + "add-author",
  getAllAuthers: AUTHER_BASE_URL + "list-authors",
  changeAutherStatus: AUTHER_BASE_URL + "change-status",
  deleteAuther: AUTHER_BASE_URL + "delete-author",
  getAllAuthorsWithoutPagination: AUTHER_BASE_URL + "get-all-author",
  getAllAuthors: AUTHER_BASE_URL + "getAuthorDetailById",

  //TestiMonial Service End Poibtes

  addTestiMonial: TESTIMONIAL_BASE_URL + "add-testimonial",
  getTestimonial: TESTIMONIAL_BASE_URL + "list-all-testimonial",
  changeStatusTestimonial: TESTIMONIAL_BASE_URL + "change-status",
  deleteTestimonial: TESTIMONIAL_BASE_URL + "delete-testimonial",

  //FAQ Service End Poibtes

  addFaqCategory: FAQS_BASE_URL + "add-faq-category",
  getFaqCategorys: FAQS_BASE_URL + "list-all-faq-category",
  changeStatusFaqCategorys: FAQS_BASE_URL + "change-status",
  deleteFaqCategorys: FAQS_BASE_URL + "delete-faq-category",

  //AddFaq Service End Poibtes

  getAllFaqCategoryWithoutPagination: FAQS_BASE_URL + "get-all-faq-category",
  addFaq: FAQS_URL + "add-faq",
  getFaq: FAQS_URL + "list-all-faq",
  changeStatusFaq: FAQS_URL + "change-status",
  deleteFaq: FAQS_URL + "delete-faq",

  //Dynmic Service End Poibtes
  getAllContact: CONTACT_URL + "list-all-contact",
  deleteContact: CONTACT_URL + "delete-contact",
  getAllRegistration: REGISTRATION_URL + "list-all-user",
  getAllUsersWithoutPagination: REGISTRATION_URL + "get-all-user",
  getAllBharasetExam: BHARASETEXAM_URL + "list-all-bharat-sat-package",
  getAllBharatSatPackagesWithoutPagination:
    BHARASETEXAM_URL + "get-all-bharatsatpackage",
  getAllPackagePurchased:
    REGISTRATION_URL + "get-all-student-package-purchased",
  getAllStudentPackagePurchasedWithoutPagination:
    REGISTRATION_URL + "list-all-student-package-purchased",
  deletUser: REGISTRATION_URL + "delete-user",
  getAllCoordinator: COORDINATOR_URL + "list-all-coordinator",
  getAllCoordinatorWithoutPagination: COORDINATOR_URL + "get-all-coordinator",
  deleteCoordinator: COORDINATOR_URL + "delete-coordinator",
  addPrivacyPolicy: PRIVACY_POLICY_URL + "add-privacy-policy",
  addTermsandConditions: TERMS_AND_CONDITIONS + "add-terms-condition",
  getTermsConditions: TERMS_AND_CONDITIONS + "get-terms-condition",
  getCancellationPolicy: CANCELLATION_POLICY + "get-cancellation-Condition",
  getPrivacyPolicy: PRIVACY_POLICY_URL + "get-privacy-policy",
  addCancellationPolicy: CANCELLATION_POLICY + "add-cancellation-Condition",
  addAboutUs: ABOUT_US_URL + "updateAboutUsPageContent",
  getAboutUsPageContent: ABOUT_US_URL + "getAboutUsPageContent",
  getSocialContactInfo: SOCIAL_MEDIA_URL + "getSocialContactInfo",
  updateSocialContactInfo: SOCIAL_MEDIA_URL + "updateSocialContactInfo",
  getHomeSliderData: HOMEPAGE_SLIDER_IMAGE + "getHomeData",
  updateSliderData: HOMEPAGE_SLIDER_IMAGE + "updateSliderData",
  updateMobileBanner: MOBILE_BANNER + "update-mobile-banner",

  // State Master
  state: STATE_BASE_URL,
  changeStateStatus: STATE_BASE_URL + "changeStatus",
  deleteState: STATE_BASE_URL + "delete",
  getAllStates: STATE_BASE_URL + "all",
  bulkUploadState: STATE_BASE_URL + "bulk-upload",

  // District Master
  district: {
    baseUrl: DISTRICT_BASE_URL,
    changeStatus: DISTRICT_BASE_URL + "/changeStatus",
    delete: DISTRICT_BASE_URL + "/delete",
    getAll: DISTRICT_BASE_URL + "/all",
  },

  // Taluka Master
  taluka: {
    baseUrl: TALUKA_BASE_URL,
    changeStatus: TALUKA_BASE_URL + "/changeStatus",
    delete: TALUKA_BASE_URL + "/delete",
    getAll: TALUKA_BASE_URL + "/all",
  },

  // Pincode Master
  pincode: {
    baseUrl: PINCODE_BASE_URL,
    changeStatus: PINCODE_BASE_URL + "/changeStatus",
    delete: PINCODE_BASE_URL + "/delete",
    getAll: PINCODE_BASE_URL + "/all",
  },
  // -Mock Test Service Endpoints
  getAllMockTest: MOCK_TEST_BASE_URL + "list-all-mock-test",
  getAllMockTestWithoutPagination: MOCK_TEST_BASE_URL + "get-all-mock-test",
  deleteMockTest: MOCK_TEST_BASE_URL + "delete-mock-test",
  addMockTest: MOCK_TEST_BASE_URL + "create-mock-test",
  updateMockTest: MOCK_TEST_BASE_URL + "updateSubject",
  updateMockTestStatus: MOCK_TEST_BASE_URL + "change-status",

  //-Packages
  getAllPackages: PACKAGES_BASE_URL + "list-all-package",
  getAllPackagesWithoutPagination: PACKAGES_BASE_URL + "getPackageDetailById",
  getAppicablePackagesWithoutPagination:
    PACKAGES_BASE_URL + "list-all-package-with-out-pagination",
  deletePackages: PACKAGES_BASE_URL + "delete-package",
  addPackages: PACKAGES_BASE_URL + "add-package",
  // updatePackages: PACKAGES_BASE_URL + "updatePackages",
  updatePackagesStatus: PACKAGES_BASE_URL + "change-status",
  updateCoordinatorStatus: COORDINATOR_URL + "update-status",
  updateCommission: COORDINATOR_URL + "update-commission",
  getAllPurchaseList: COORDINATOR_URL + "getCoordinatorPurchaseListApi",
  getAllCoordinatorDetail: COORDINATOR_URL + "coordinator/",
  addCoordinator: COORDINATOR_URL + "add-coordinator",
  editCoordinator: COORDINATOR_URL + "edit",
  getAllCoordinatorRequest: COORDINATOR_URL + "getRequestDetailApi",
  getAllCoordinatorWithdrawlRequest: COORDINATOR_URL + "withdraw-requests",
  withdrwalRequest: COORDINATOR_URL + "approve-withdraw-request",
  transactionHistory: COORDINATOR_URL + "transaction-history",
  //Sub Admin
  addRole: ROLE_BASE_URL + "create-role",
  getAllRoles: ROLE_BASE_URL + "list-all-role",
  deleteRole: ROLE_BASE_URL + "delete-role",
  deleteSingleSubAdmin: ADMIN_BASE_URL + "delete-admin",
  updateRoleStatus: ROLE_BASE_URL + "change-status",
  updateSubAdminStatus: ADMIN_BASE_URL + "change-status",
  getAllRoleList: ROLE_BASE_URL + "get-all-role",
  addSubAdmin: ADMIN_BASE_URL + "add-sub-admin",
  getAllsubAdmins: ADMIN_BASE_URL + "list-all-sub-admin",
  updateRolePrivileges: ROLE_BASE_URL + "update-role-privileges",

  // STUDENT BATCH
  addStudentBatch: STUDENT_BATCH_BASE_URL + "create-batch",
  getAllStudentBatch: STUDENT_BATCH_BASE_URL + "list",
  deletebharatsatresult: BHARATSATEXAMRESULT_BASE_URL + "delete-view-result",
  getBharatSatViewExamList: BHARATSATEXAMRESULT_BASE_URL + "viewResult",
  addstudentrank: BHARATSATEXAMRESULT_BASE_URL + "update-rank",
  getBharatSatExamReult: BHARATSATEXAMRESULT_BASE_URL + "getShowResults",
  addBharatSatExam: BHARATSATEXAM_BASE_URL + "create-exam",
  getBharatSatExamList: BHARATSATEXAM_BASE_URL + "list-all-exam",
  getStudentBatchList: BHARATSATEXAM_BASE_URL + "student-batch-list",
  getStudentBatchListWithoutPagination: BHARATSATEXAM_BASE_URL + "student-batch-list-Without-pagination",
  deleteStudentBatch: BHARATSATEXAM_BASE_URL + "delete-student-batch",
  changeStatusBharatSatExam: BHARATSATEXAM_BASE_URL + "change-status",
  deleteBharatSatExam: BHARATSATEXAM_BASE_URL + "delete-exam",
  bharatSatQuestionsDetails:
    BHARATSATEXAM_BASE_URL + "bharatSat-question-paper",
  generatehallticketbhratsat:
    BHARATSATEXAM_BASE_URL + "generate-e-hall-ticket-bharatSat",
  editStudentDetails: REGISTRATION_URL + "update-user",
  // updateStudentBatch: STUDENT_BATCH_BASE_URL + "update-student-batch",
  // deleteStudentBatch: STUDENT_BATCH_BASE_URL + "delete-student-batch",

  // REVIEWER
  getAllReviewerQuestionList: REVIEWER_BASE_URL + "question-list",
  getAllReviewerSubQuestionList: REVIEWER_BASE_URL + "sub-question-list",
  revieweraddSubQuestion: REVIEWER_BASE_URL + "update-sub-question",
  revieweraddQuestion: REVIEWER_BASE_URL + "update-question",
  reviewerdeleteSubQuestion: REVIEWER_BASE_URL + "delete-sub-question",
  reviewerupdateStatus: REVIEWER_BASE_URL + "update-status",
  getreviewerhistorylist: REVIEWER_BASE_URL + "history-list",
  deleteReviewerQuestionList: REVIEWER_BASE_URL + "delete-question",

  //COUPON
  addCoupon: COUPON_BASE_URL + "create",
  getAllCoupons: COUPON_BASE_URL + "list",
  deleteCoupon: COUPON_BASE_URL + "delete",
  updateCouponStatus: COUPON_BASE_URL + "update-status",
  getAllCouponsWithoutPagination: COUPON_BASE_URL + "list-withoutPagination",
};

export default ApiConstants;
